/* E-Tech61 premium buy panel. Pairs with snippets/et61-pdp.liquid.
   Store facts arrive in #e6Data (from theme settings). Re-initialises when the theme editor
   re-renders the section, and cleans up its listeners, timers and sticky bar first. */
(() => {
  if (window.__e6Loaded) return;
  window.__e6Loaded = true;
  let teardown = null;

  function init() {
    if (teardown) teardown();
    const root = document.getElementById('e6');
    const dataEl = document.getElementById('e6Data');
    if (!root || !dataEl) return;

    const D = JSON.parse(dataEl.textContent);
    const ac = new AbortController();
    const opt = { signal: ac.signal };
    const timers = [];
    const html = document.documentElement;
    const $ = (s, r = document) => r.querySelector(s);
    const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
    const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const T = window.theme || {};
    // Same formatter as the theme (matches Liquid `money`); Intl fallback outside the theme.
    const money = (cents) => (T.Currency && T.settings && T.settings.moneyFormat
      ? T.Currency.formatMoney(cents, T.settings.moneyFormat)
      : new Intl.NumberFormat(D.locale || 'en-GB', { style: 'currency', currency: D.currency || 'GBP' }).format(cents / 100));
    const setMoney = (el, cents) => { if (el) el.innerHTML = money(cents); };

    let cur = D.variants.find((v) => v.id === D.current) || D.variants[0];
    const sticky = $('#e6Sticky'), stAdd = $('#e6StAdd');
    let cartTotal = 0, cartCount = 0, cartBat = false; // cartBat: a battery in the cart still ships by Evri
    let svc = 't48', busy = false, leaving = false;
    const qtyEl = $('#e6Qty');
    // Never ask for more than the store can sell when it tracks stock and won't oversell.
    const qty = () => Math.min(Math.max(1, parseInt(qtyEl.value, 10) || 1), cur.max || Infinity);
    // Add-on inputs (server-rendered essentials and fetched rows) carry data-id/-price/-battery/-pid.
    const checked = () => $$('#e6Adds input:checked');

    // Multi-buy tiers mirror the store's automatic discounts and count every item in the cart.
    const tiers = (D.tiers || []).filter((t) => t[0] > 0 && t[1] > 0).sort((a, b) => a[0] - b[0]);
    const pct = (n) => tiers.reduce((d, t) => (n >= t[0] ? t[1] : d), 0);
    const nextTier = (n) => tiers.find((t) => t[0] > n);
    // Measured on /cart.js (2 Oct 2026): Shopify floors the percentage of the combined subtotal,
    // then allocates it across lines. ponytail: estimate covers this purchase only, so it can be
    // 1p off when the cart already holds items (the floor then runs over the whole cart).
    const saving = (amount, d) => Math.floor((amount * d) / 100);

    /* ---------- options ---------- */
    const groups = $$('.e6-opt', root);
    if (groups.length === 1 && new Set(D.variants.map((v) => v.p)).size > 1) {
      $$('.e6-val', groups[0]).forEach((b) => {
        const v = D.variants.find((x) => x.o[0] === b.dataset.v);
        if (v) setMoney($('small', b), v.p);
      });
    }
    groups.forEach((g) => g.addEventListener('click', (e) => {
      const b = e.target.closest('.e6-val');
      if (!b) return;
      const i = +g.dataset.i, val = b.dataset.v, want = cur.o.slice();
      want[i] = val;
      const next = D.variants.find((v) => v.o.every((x, j) => x === want[j]))
        || D.variants.find((v) => v.o[i] === val && v.a)
        || D.variants.find((v) => v.o[i] === val);
      if (next) setVariant(next);
    }, opt));

    function setVariant(v) {
      cur = v;
      const u = new URL(location.href);
      u.searchParams.set('variant', v.id);
      history.replaceState(history.state, '', u);
      if (v.m) showMedia(v.m);
      paint();
    }

    // Scroll the theme gallery (horizontally) to the variant's image.
    function showMedia(id) {
      const section = root.closest('.shopify-section') || document;
      const slider = $('media-gallery slider-element', section);
      if (!slider || !slider.itemsToShow || typeof slider.select !== 'function') return;
      const idx = slider.itemsToShow.findIndex((el) => el.getAttribute('data-media-id') === String(id));
      if (idx > -1) slider.select(idx + 1);
    }

    const helpBtn = $('#e6HelpBtn'), tip = $('#e6Tip');
    if (helpBtn) helpBtn.addEventListener('click', () => { tip.hidden = !tip.hidden; helpBtn.setAttribute('aria-expanded', !tip.hidden); }, opt);

    /* ---------- quantity ---------- */
    const setQty = (n) => { qtyEl.value = n; qtyEl.value = qty(); paint(); };
    $$('.e6-qty button', root).forEach((b) => b.addEventListener('click', () => setQty(Math.max(1, qty() + +b.dataset.step)), opt));
    // Typing past the stock cap snaps back to it straight away, so field, total and tiers agree.
    qtyEl.addEventListener('input', () => { if (cur.max && parseInt(qtyEl.value, 10) > cur.max) qtyEl.value = cur.max; paint(); }, opt);
    qtyEl.addEventListener('blur', () => { qtyEl.value = qty(); }, opt);
    $$('.e6-tier', root).forEach((b) => b.addEventListener('click', () => setQty(b.dataset.q), opt));

    /* ---------- render ---------- */
    function paint() {
      const q = qty();
      const adds = checked();
      const units = cartCount + q + adds.length;
      const d = pct(units);
      const sum = (els) => els.reduce((s, el) => s + (+el.dataset.price || 0), 0);
      const full = cur.p * q + sum(adds);
      const saved = saving(full, d);
      const total = full - saved;
      // Shopify's price-based Tracked 48 rate looks at the whole cart, batteries included
      // (/cart/shipping_rates.json, 2 Oct 2026); batteries themselves still go by Evri.
      const bats = adds.filter((el) => el.dataset.battery === 'true');

      groups.forEach((g) => {
        const i = +g.dataset.i;
        $('[data-sel]', g).textContent = cur.o[i];
        $$('.e6-val', g).forEach((b) => {
          const val = b.dataset.v;
          const on = cur.o[i] === val;
          const match = D.variants.find((v) => v.o[i] === val && v.o.every((x, j) => j === i || x === cur.o[j]));
          b.classList.toggle('on', on);
          b.setAttribute('aria-pressed', on);
          b.classList.toggle('na', !match || !match.a);
        });
      });

      setMoney($('#e6Price'), cur.p);
      const cmp = cur.c > cur.p ? cur.c : 0;
      if (cmp) setMoney($('#e6Compare'), cmp); else $('#e6Compare').textContent = '';
      const off = $('#e6Off');
      off.hidden = !cmp;
      if (cmp) off.textContent = 'Save ' + Math.floor(((cmp - cur.p) / cmp) * 100) + '%';
      if (D.vat) setMoney($('#e6Ex'), Math.round(cur.p / 1.2));

      const st = $('#e6Stock');
      const low = cur.q && cur.q <= 5;
      st.className = 'e6-stock' + (!cur.a ? ' out' : low ? ' low' : '');
      $('span', st).textContent = !cur.a ? 'Sold out'
        : low ? 'Only ' + cur.q + ' left'
        : cur.q ? 'In stock · ' + cur.q + ' available' : 'In stock';

      $$('.e6-tier', root).forEach((b) => {
        const bq = +b.dataset.q;
        const bf = cur.p * bq;
        const bn = bf - saving(bf, +b.dataset.d);
        const on = bq === Math.min(q, tiers.length ? tiers[tiers.length - 1][0] : 1);
        setMoney($('.p', b), bn);
        $('.e', b).innerHTML = money(Math.round(bn / bq)) + ' each';
        b.classList.toggle('on', on);
        b.setAttribute('aria-pressed', on);
      });
      const note = $('#e6TierNote');
      if (note) {
        const nt = nextTier(units);
        const more = nt ? nt[0] - units : 0;
        const inCart = cartCount ? ' Counts the ' + cartCount + ' item' + (cartCount > 1 ? 's' : '') + ' in your cart.' : '';
        note.innerHTML = (d
          ? '<em>You save ' + money(saved) + ' (' + d + '%)</em> &mdash; applied at checkout.'
            + (nt ? ' Add ' + more + ' more to save ' + nt[1] + '%.' : '')
          : (nt ? 'Add <b>' + more + ' more item' + (more > 1 ? 's' : '') + '</b> to save ' + nt[1] + '% &mdash; mix any parts.' : '')) + inCart;
      }

      $('#e6Add').disabled = !cur.a;
      $('#e6AddTxt').textContent = cur.a ? 'Add to cart' : 'Sold out';
      if (stAdd) { stAdd.disabled = !cur.a; stAdd.textContent = cur.a ? 'Add to cart' : 'Sold out'; }
      if (cur.max) qtyEl.max = cur.max; else qtyEl.removeAttribute('max');
      setMoney($('#e6Total'), total);
      setMoney($('#e6StPrice', document), cur.p);

      const form = $('#e6Form');
      if (form) {
        form.elements.id.value = cur.id;
        form.elements.quantity.value = q;
        form.hidden = !cur.a;
        const nb = $('#e6Now');
        if (nb) nb.hidden = !cur.a;
      }
      $('#e6XHint').hidden = !adds.length || !cur.a;
      freeMeter(total, bats.length > 0 || cartBat);
    }

    function freeMeter(total, bat) {
      const box = $('#e6Free');
      if (!box || !D.freeFrom) return;
      const sum = cartTotal + total;
      const left = D.freeFrom - sum;
      box.classList.toggle('done', left <= 0);
      $('#e6Bar').style.width = Math.min(100, (sum / D.freeFrom) * 100) + '%';
      $('#e6FreeTxt').innerHTML = (left <= 0
        ? (bat ? '✓ FREE Royal Mail Tracked 48 on your other parts' : '✓ This order qualifies for FREE Royal Mail Tracked 48')
        : 'Add <b>' + money(left) + '</b> more for FREE Tracked 48 delivery')
        + (bat ? '<br><small>Batteries ship separately by Evri.</small>' : '');
      const t48 = $('#e6T48');
      if (t48) {
        if (left <= 0) t48.textContent = 'Free'; else setMoney(t48, D.t48);
        t48.classList.toggle('free', left <= 0);
      }
    }

    const setCart = (c) => { cartTotal = c.total_price || 0; cartCount = c.item_count || 0; cartBat = (c.items || []).some((i) => i.product_type === 'Battery'); };
    function refreshCart() {
      return fetch(base + 'cart.js', { headers: { Accept: 'application/json' }, signal: ac.signal })
        .then((r) => r.json())
        .then((c) => { setCart(c); paint(); return c; })
        .catch(() => null);
    }

    // Keep the cart figures current when the cart changes elsewhere (drawer, cart page, other forms).
    // Only reads and repaints, never publishes, so our own publish can't loop back.
    const PS = T.pubsub && T.pubsub.PUB_SUB_EVENTS ? T.pubsub : null;
    const unsub = PS ? PS.subscribe(PS.PUB_SUB_EVENTS.cartUpdate, (e) => {
      const c = e && e.cart;
      if (!c || c.errors) return;
      if (typeof c.item_count === 'number' && typeof c.total_price === 'number' && Array.isArray(c.items)) {
        setCart(c);
        paint();
      } else refreshCart(); // e.g. the theme form publishes the /cart/add.js line, not the cart
    }) : null;
    // Cart changes that only ask the drawer to re-render (cart:refresh) don't publish cartUpdate.
    document.addEventListener('cart:refresh', () => refreshCart(), opt);

    /* ---------- dispatch countdown + delivery dates (UK time) ---------- */
    const BANK = (D.holidays || []).map((s) => String(s).trim()).filter(Boolean);
    const SVC = { t48: [2, 3, 'Royal Mail Tracked 48®'], sd: [1, 1, 'Special Delivery Guaranteed by 1pm®'] };
    const ymd = (d) => d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
    const workday = (d) => d.getDay() > 0 && d.getDay() < 6 && !BANK.includes(ymd(d));
    const addWorkdays = (d, n) => { const r = new Date(d); while (n > 0) { r.setDate(r.getDate() + 1); if (workday(r)) n--; } return r; };
    const fmt = (d) => d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
    const pad = (n) => String(n).padStart(2, '0');
    const hour = (h) => (h > 12 ? h - 12 + 'pm' : h === 12 ? '12pm' : h + 'am');
    const range = (k, disp) => {
      const a = addWorkdays(disp, SVC[k][0]);
      const b = addWorkdays(disp, SVC[k][1]);
      return +a === +b ? fmt(a) : fmt(a) + ' – ' + fmt(b);
    };
    const ukFmt = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London', year: 'numeric', month: 'numeric', day: 'numeric',
      hour: 'numeric', minute: 'numeric', second: 'numeric', hourCycle: 'h23'
    });
    function ukNow() {
      const o = {};
      ukFmt.formatToParts(new Date()).forEach((p) => { o[p.type] = +p.value; });
      return new Date(o.year, o.month - 1, o.day, o.hour, o.minute, o.second);
    }

    // UK Royal Mail estimates only; batteries and international orders see "See checkout".
    // Dates, cutoff and opening state only change on the hour or with the service, so they are
    // rebuilt when that key changes; the clock alone updates every second.
    const estimates = D.uk && !D.battery;
    let tickKey = '';
    let clock = null;
    let nextCut = null;
    // Respect reduced-motion users: no seconds ticking, minutes only.
    const calm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    function tick() {
      // Skip work in background tabs, but always draw once so the card is never empty.
      if (document.hidden && tickKey) return;
      const now = ukNow();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const cutoff = new Date(today);
      cutoff.setHours(D.cutoff || 16);
      const same = workday(today) && now < cutoff;
      const key = ymd(today) + '|' + now.getHours() + '|' + svc;
      if (key !== tickKey) {
        tickKey = key;
        const disp = same ? today : addWorkdays(today, 1);
        const tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate() + 1);
        // Count down to the cut-off the next order will make: today's, or the next working day's.
        nextCut = new Date(disp);
        nextCut.setHours(D.cutoff || 16, 0, 0, 0);
        const when = same ? 'today' : +disp === +tomorrow ? 'tomorrow' : fmt(disp);
        const cut = $('#e6Cut');
        cut.innerHTML = 'Order within <span class="e6-clock"><span></span><span></span><span></span></span> for <b>dispatch ' + when + '</b>';
        clock = $$('.e6-clock span', cut);
        $('#e6D1').textContent = same ? 'Today' : fmt(disp);
        if (estimates) {
          $('#e6D2').textContent = range(svc, disp);
          $('#e6Svc').innerHTML = '<b>' + SVC[svc][2] + '</b> &middot; dispatched from Manchester';
          $$('[data-eta]', root).forEach((el) => { el.textContent = 'Arrives ' + range(el.dataset.eta, disp); });
        }
        const open = workday(today) && now.getHours() >= (D.open || 10) && now.getHours() < (D.close || 18);
        const o = $('#e6Open');
        o.classList.toggle('on', open);
        o.textContent = open ? 'Open now · until ' + hour(D.close || 18) : 'Mon–Fri ' + hour(D.open || 10) + '–' + hour(D.close || 18);
      }
      if (clock && nextCut) {
        const s = Math.max(0, Math.floor((nextCut - now) / 1000));
        const parts = s >= 86400
          ? [Math.floor(s / 86400) + 'd', pad(Math.floor((s % 86400) / 3600)) + 'h', pad(Math.floor((s % 3600) / 60)) + 'm']
          : [pad(Math.floor(s / 3600)) + 'h', pad(Math.floor((s % 3600) / 60)) + 'm', calm ? '' : pad(s % 60) + 's'];
        parts.forEach((t, i) => { clock[i].textContent = t; clock[i].hidden = !t; });
      }
    }
    document.addEventListener('visibilitychange', tick, opt);

    $$('#e6Svcs button[data-s]').forEach((b) => b.addEventListener('click', () => {
      svc = b.dataset.s;
      $$('#e6Svcs button[data-s]').forEach((x) => {
        x.classList.toggle('on', x === b);
        x.setAttribute('aria-pressed', x === b);
      });
      tick();
    }, opt));

    /* ---------- complete the repair: same-model parts from the store's search ---------- */
    // Server-rendered essentials (label.is-essential) come first in #e6Adds; same-model rows are
    // fetched and put where the .e6-skel placeholders were, skipping essentials and this product.
    function loadAddons() {
      const block = $('#e6AddBlock');
      const list = $('#e6Adds');
      if (!block || !list) return;
      list.addEventListener('change', paint, opt);
      const ess = $$('input', list);
      const pids = new Set([String(D.id)].concat(ess.map((el) => String(el.dataset.pid))));
      const vids = new Set(ess.map((el) => String(el.dataset.id)));
      const done = (rows) => {
        block.removeAttribute('aria-busy');
        $$('.e6-skel', list).forEach((el) => el.remove());
        if (!rows.length) {
          if (!ess.length) block.hidden = true;
          return;
        }
        const label = (n) => 'Show ' + n + ' more';
        list.insertAdjacentHTML('beforeend', rows.map((a, i) => '<label class="e6-add-row' + (i > 1 ? ' x' : '') + '">'
          + '<input type="checkbox" data-id="' + a.id + '" data-price="' + a.price + '" data-battery="' + a.bat + '" data-pid="' + a.pid + '">'
          + '<span class="e6-box" aria-hidden="true"><svg viewBox="0 0 24 24" focusable="false"><path d="M20 6 9 17l-5-5"/></svg></span>'
          + (a.img ? '<img src="' + esc(a.img + (a.img.indexOf('?') > -1 ? '&' : '?') + 'width=120') + '" alt="" loading="lazy" width="34" height="34">' : '')
          + '<span class="n">' + esc(a.t) + '</span><span class="pr">+' + money(a.price) + '</span></label>').join('')
          + (rows.length > 2 ? '<button type="button" class="e6-more" aria-expanded="false">' + label(rows.length - 2) + '</button>' : ''));
        const more = $('.e6-more', list);
        if (more) more.addEventListener('click', () => {
          const open = list.classList.toggle('open');
          more.setAttribute('aria-expanded', open);
          more.textContent = open ? 'Show fewer' : label(rows.length - 2);
        }, opt);
        paint();
      };
      if (!D.model) return done([]);

      const m = D.model.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const exact = new RegExp('(^|\\W)' + m + '(?![\\w+]| (Pro|Max|Plus|Mini|mini|Ultra|Lite|FE|Edge|Fold|Flip|XL|Neo|Fusion|5G Pro)\\b)', 'i');
      const url = base + 'search/suggest.json?q=' + encodeURIComponent(D.model)
        + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=hide&resources[options][fields]=title,tag';

      fetch(url, opt)
        .then((r) => r.json())
        .then((j) => {
          const found = ((j.resources && j.resources.results && j.resources.results.products) || [])
            // Batteries ship within the UK only, so don't offer them to other countries.
            .filter((p) => !pids.has(String(p.id)) && p.available && p.type !== D.type && (D.uk || p.type !== 'Battery') && exact.test(p.title))
            .slice(0, 4);
          return Promise.all(found.map((p) => fetch(base + 'products/' + p.handle + '.js', opt)
            .then((r) => r.json())
            .then((pj) => {
              const v = pj.variants.find((x) => x.available);
              if (!v || vids.has(String(v.id)) || pids.has(String(pj.id))) return null;
              let img = pj.featured_image || '';
              if (img.indexOf('//') === 0) img = 'https:' + img;
              return { id: v.id, pid: pj.id, price: v.price, bat: pj.type === 'Battery', img, t: pj.title.split('|')[0].replace(/^For\s+/i, '').trim() };
            })
            .catch(() => null)));
        })
        .then((items) => done((items || []).filter(Boolean)))
        .catch((e) => { if (e.name !== 'AbortError') done([]); });
    }

    /* ---------- add to cart through the theme's cart route, then open its drawer ---------- */
    const release = () => { busy = false; addBtns.forEach((b) => { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); }); };
    const status = $('#e6Status');
    const nowBtn = $('#e6Now');
    const addBtns = [$('#e6Add'), stAdd, nowBtn].filter(Boolean);
    // goCheckout: "Buy it now" adds the item and ticked add-ons, then opens checkout instead of the drawer.
    function addToCart(btn, goCheckout) {
      // One guard for the main and sticky buttons so a double tap can't add twice.
      if (!cur.a || busy) return;
      busy = true;
      btn.classList.add('is-loading');
      addBtns.forEach((b) => b.setAttribute('aria-busy', 'true'));
      const err = $('#e6Err');
      err.hidden = true;
      status.textContent = '';
      const items = [{ id: cur.id, quantity: qty() }];
      checked().forEach((el) => { if (+el.dataset.id) items.push({ id: +el.dataset.id, quantity: 1 }); });
      const sections = [];
      html.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections } }));

      fetch(base + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items, sections, sections_url: location.pathname })
      })
        .then((r) => r.json())
        .then((res) => {
          if (res.status) {
            err.textContent = res.description || res.message || 'Could not add to cart.';
            err.hidden = false;
            // Shopify may still add part of the quantity: sync the cart count and re-render the drawer.
            return refreshCart().then((cart) => {
              try { if (cart && PS) PS.publish(PS.PUB_SUB_EVENTS.cartUpdate, { source: 'product-bundle', cart }); } catch (e) { /* refresh below */ }
              document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false } }));
            });
          }
          // Keep the spinner and the busy guard while the browser goes to checkout, so a second tap can't add again.
          if (goCheckout) { leaving = true; location.href = base + 'checkout'; return; }
          return refreshCart().then((cart) => {
            if (!cart) return;
            status.textContent = 'Added to cart. Cart now has ' + cart.item_count + ' item' + (cart.item_count === 1 ? '' : 's') + '.';
            checked().forEach((el) => { el.checked = false; });
            paint();
            // cart.js parses cart.sections[id] whenever sections is defined, and Shopify can return
            // null for a section, so pass them only when every requested one came back as HTML.
            const fresh = res.sections && sections.every((id) => typeof res.sections[id] === 'string');
            if (fresh) cart.sections = res.sections;
            // The add has succeeded: a theme subscriber throwing must not turn it into an error.
            let synced = fresh;
            try { if (PS) PS.publish(PS.PUB_SUB_EVENTS.cartUpdate, { source: 'product-bundle', cart }); } catch (e) { synced = false; }
            if (!synced) document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false } }));
            const drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.show === 'function' && !(T.settings && T.settings.cartType === 'page')) {
              try { drawer.show(btn); } catch (e) { location.href = base + 'cart'; }
            } else location.href = base + 'cart';
          });
        })
        .catch(() => { err.textContent = 'Something went wrong. Please try again.'; err.hidden = false; })
        .finally(() => { if (!leaving) release(); });
    }

    /* ---------- sticky bar once the main button scrolls away ---------- */
    if (sticky) document.body.appendChild(sticky);
    $('#e6Add').addEventListener('click', function () { addToCart(this); }, opt);
    if (stAdd) stAdd.addEventListener('click', function () { addToCart(this); }, opt);
    if (nowBtn) nowBtn.addEventListener('click', function () { addToCart(this, true); }, opt);
    // Back from checkout restores this page from the back/forward cache: free the buttons, re-read the cart.
    addEventListener('pageshow', (e) => {
      if (!e.persisted) return;
      refreshCart();
      if (leaving) { leaving = false; release(); }
    }, opt);
    let shown = null, dockH = -1, queued = false;
    const dock = $('nav.mobile-dock');
    // The theme slides the dock in and out. Use where it is heading (the classes its own
    // .product-sticky-form CSS uses) and let CSS move the bar with it, not where it is mid-slide.
    const dockOverlap = () => {
      if (!dock) return 0;
      const cs = getComputedStyle(dock);
      if (cs.display === 'none' || cs.visibility === 'hidden') return 0;
      const on = dock.classList.contains('active') || !!dock.closest('.mobile-dock-section.active, .mobile-dock-section.shopify-active')
        || !!$('.header-sticky.header-hidden ~ .mobile-dock-section');
      const top = dock.getBoundingClientRect().top - new DOMMatrixReadOnly(cs.transform).m42; // top once settled in view
      return on && top < innerHeight ? Math.round(innerHeight - top) : 0;
    };
    function checkSticky() {
      queued = false;
      if (!sticky) return;
      const show = $('#e6Add').getBoundingClientRect().bottom < 0;
      const dh = show ? dockOverlap() : 0;
      if (show === shown && dh === dockH) return;
      shown = show;
      dockH = dh;
      let reserve = 0;
      if (show) {
        sticky.style.setProperty('--e6-dock', dh + 'px'); // sit above the visible part of the dock
        reserve = sticky.offsetHeight + dh;
        html.style.setProperty('--e6-st', reserve + 'px');
      }
      // WCAG 2.4.11: keep focused elements from scrolling underneath the bar
      html.style.scrollPaddingBottom = show ? reserve + 'px' : '';
      html.classList.toggle('e6-st-on', show);
      sticky.classList.toggle('show', show);
      sticky.setAttribute('aria-hidden', !show);
      if (stAdd) stAdd.tabIndex = show ? 0 : -1;
    }
    const queue = () => { if (!queued) { queued = true; requestAnimationFrame(checkSticky); } };
    window.addEventListener('scroll', queue, { passive: true, signal: ac.signal });
    window.addEventListener('resize', queue, opt);
    if (dock) ['transitionrun', 'transitionend'].forEach((t) => dock.addEventListener(t, queue, opt));

    paint();
    tick();
    timers.push(setInterval(tick, 1000));
    checkSticky();
    refreshCart();
    loadAddons();

    teardown = () => {
      ac.abort();
      if (unsub) unsub();
      timers.forEach(clearInterval);
      if (sticky) sticky.remove();
      html.classList.remove('e6-st-on');
      html.style.scrollPaddingBottom = '';
      teardown = null;
    };
  }

  // Theme editor: scripts don't re-run when a section re-renders, so re-initialise here.
  document.addEventListener('shopify:section:unload', (e) => { if (teardown && e.target.querySelector('#e6')) teardown(); });
  document.addEventListener('shopify:section:load', (e) => { if (e.target.querySelector('#e6')) init(); });
  init();
})();
